const filterBtns = document.querySelectorAll('.filter-buttons .filter-button'),
      productCards = document.querySelectorAll('.product-card-container'),
      titleCards = document.querySelectorAll('.title-card');

let selectedFlavorTags = [];


function productEmptyCheck(){
  const container = document.querySelectorAll('.list-container');

  container.forEach(function(container){
    const cards = container.querySelectorAll('.product-card-container'),
          titleCard = container.querySelector('.title-card'),
          parentEl = container.parentElement,
          grandParentEl = parentEl.parentElement;

    let counter = 0,
        cardLength = 0;

    cards.forEach(function(card){
      cardLength++;

      if(card.classList.contains('hide')){
         counter++;
      }
      if(cardLength == counter){
        titleCard.classList.add('hide');
        grandParentEl.classList.add('hide');
      }else {
        if(titleCard.classList.contains('hide')){
          titleCard.classList.remove('hide');
          grandParentEl.classList.remove('hide');
        }
      }
    })
  })
}
// ============= HIDING PRODUCTS WITHOUT FLAVOR =============
function hideProductsFlavor(){
  productCards.forEach(function(card){
    if (!selectedFlavorTags.includes(card.getAttribute('data-flavor'))) {
      card.classList.add('hide');
    }
  });
}

// ============= UNHIDING PRODUCTS WITH FLAVOR =============
function unhideProductsFlavor(){
  productCards.forEach(function(card){
    const containsItem = selectedFlavorTags.some(flavor => card.getAttribute('data-flavor').includes(flavor))
    if(selectedFlavorTags.length){
      if (containsItem) {
          card.classList.remove('hide');
      }
    }else {
      card.classList.remove('hide');
    }

  });
}

// ============= SHOW ALL PRODUCTS =============
function showAll(){
  selectedFlavorTags.splice(0, selectedFlavorTags.length);

  productCards.forEach(function(card){
    if(card.classList.contains('hide')){
      card.classList.remove('hide');
    }
  });
  filterBtns.forEach(function(button){
    if(!button.classList.contains('all')){
      button.classList.remove('selected');
    }else {
      button.classList.add('selected');
    }
  });
  titleCards.forEach(function(card){
    if(card.classList.contains('hide')){
      card.classList.remove('hide');
    }
  });
}

// ============= CLICK HANDLER =============
filterBtns.forEach(function(button){
  button.addEventListener('click', function(){
    const allBtn = document.querySelector('.filter-button.all'),
          activeFlavorBtn = document.querySelector('.filter-button.flavor.selected');

    let filter = button.getAttribute("data-filter");

    // ============= ALL FILTER SELECTED =============
    if(filter == "All"){
      showAll();
      return
    }
    // ============= FLAVOR FILTER SELECTED =============
     if(button.classList.contains('flavor')){
      if(button.classList.contains('selected')) {
        button.classList.remove('selected');
      }else {
        
        if(!allBtn.classList.contains('selected')){
          if(activeFlavorBtn){
            activeFlavorBtn.classList.remove('selected');
          }
          button.classList.add('selected');
        }else {
          
          button.classList.add('selected');
          allBtn.classList.remove('selected');
        }
      }

      if(!selectedFlavorTags.includes(filter)){
        selectedFlavorTags.splice(0, selectedFlavorTags.length);
        selectedFlavorTags.push(filter);
        hideProductsFlavor();
        unhideProductsFlavor();
      }else {
        let index = selectedFlavorTags.indexOf(filter);
        selectedFlavorTags.splice(index,1);
        unhideProductsFlavor();
      }
      productEmptyCheck();
    }
  });
})
